import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const HistorySvg = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9997 1.83325C16.0622 1.83325 20.1663 5.93731 20.1663 10.9999C20.1663 16.0625 16.0622 20.1666 10.9997 20.1666C5.93706 20.1666 1.83301 16.0625 1.83301
       10.9999H3.66634C3.66634 15.05 6.94958 18.3333 10.9997 18.3333C15.0498 18.3333 18.333 15.05 18.333 10.9999C18.333 6.94983 15.0498 3.66659 10.9997 3.66659C8.47904
        3.66659 6.25544 4.93831 4.93548 6.87514L7.33301 6.87492V8.70825H1.83301V3.20825H3.66634L3.66624 5.49917C5.33865 3.27311 8.00101 1.83325 10.9997 1.83325ZM11.9163
         6.41659L11.9162 10.6195L14.8887 13.5926L13.5924 14.889L10.0828 11.3785L10.083 6.41659H11.9163Z"
      fill="currentColor"
    />
  </svg>
);

const History = (props: IIconProps) => <Icon component={HistorySvg} {...props} />;

export default History;
